  $(document).ready(function() {

        var interval; // 定义变量存储定时器

        function startAutoPlay() {
            interval = setInterval(function() {
                var activeLink = $('.linkHyperlinksAndPictures.active');
                var nextLink = activeLink.next('.linkHyperlinksAndPictures');

                // 如果已经是最后一个链接，则将下一个链接设置为第一个链接
                if (nextLink.length === 0) {
                    nextLink = $('.linkHyperlinksAndPictures:first-child');
                }

                // 触发下一个链接的点击事件
                nextLink.trigger('click');
            }, 5000); // 每隔5秒进行切换
        }

        function stopAutoPlay() {
            clearInterval(interval); // 清除定时器
        }

        // 默认显示第一个超链接下的横线
        var defaultLink = $('.linkHyperlinksAndPictures:first-child');
        var underline = $('.underline');
        underline.css('height', "2.8vw");
        underline.css('top', defaultLink.position().top);


        // 默认显示第一张图片
        $('.linkHyperlinksAndPictures').removeClass('active');
        defaultLink.addClass('active');
        $('.leftLinkRightPicture-main-image:not("#image1")').hide();

        $('.linkHyperlinksAndPictures').click(function(e) {
            e.preventDefault();

            // 停止自动播放
            stopAutoPlay();

            // 切换图片
            var newImage = $(this).data('image');
            $('.linkHyperlinksAndPictures').removeClass('active');
            $(this).addClass('active');
            $('.leftLinkRightPicture-main-image').hide();
            $('#' + newImage).show();

            // 切换横线的样式
            underline.css('height', "2.5vw");
            underline.css('top', $(this).position().top);


            // 重新启动自动播放
            startAutoPlay();
        });



        $(".picturesDiv").hover(
            function() {
                stopAutoPlay();
            },
            function() {
                startAutoPlay();
            }
        )


        // 启动自动播放
        startAutoPlay();
    });
